import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button } from "react-bootstrap";
import { connect } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import "../ledger/style.css";
import { isEmpty, get } from "lodash";
import Select from "react-select";
import {redirect, Link } from "react-router-dom";
import { startFinancialDate } from "../../../../global/globalFunctions";
import moment from "moment";
import { searchAccountCashBook } from "../accountsLevels/accountsLevel.action";
import { getLevel5LedgerData } from "../ledger/Ledger.action";
import { setHeading } from "../../accounts/account.actions";

const AccountCashBook = (props) => {
  console.log("testtttttttttttttt")
  const [show, setShow] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [item, setItem] = useState("");
  const getLevel5LedgerData1 = props.level5LedgerData.map((x) => { let data = { value: x._id, label: x.allLevelKey + "" + x.levelFourName }; return data });
  
  const handleChangeLevel5Ledger = (selectedOption) => {
    setItem(selectedOption.value);
  };

  const exportPDF = () => {
    props.searchAccountCashBook(
      {
        startDate: !isEmpty(startDate) ? startDate : "",
        endDate: !isEmpty(endDate) ? endDate : "",
        levelFourId: item,
      },
      startDate,
      endDate
    );
  };

  useEffect(() => {
    props.setHeading("Cash Book")
    props.getLevel5LedgerData();
  }, []);

  // function searchData() {
  //   props.searchAccountLedger({
  //     startedDate: !isEmpty(startDate) ? startDate : "",
  //     endDate: !isEmpty(endDate) ? endDate : "",
  //     levelFiveId: item,
  //   });
  //   return <redirect to="/user/Ledger-List" />;
  // }

  return (
    <>
      {props.isFetchingLevel5LedgerData ? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
            {props.isFetchingLevel5LedgerData ? "Loading..." : "Loading..."}
          </Button>
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <Row>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label>
                    <b> Start Date </b>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label>
                    <b> End Date</b>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label>
                    <b> Select Account *</b>
                  </Form.Label>
                  <Select
                    placeholder="Select Account..."
                    onChange={handleChangeLevel5Ledger}
                    options={getLevel5LedgerData1}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="sendDiv" style={{marginTop:"15px"}}>
              {item == "" ? (
                <Button
                  disabled
                >
                  Generate Cash Book
                </Button>
              ) : (
                <Button onClick={() => exportPDF()}>
                  Generate Cash Book
                </Button>
              )}
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLevel5LedgerData: () => dispatch(getLevel5LedgerData()),
    searchAccountCashBook: (data, startDate, endDate) =>
      dispatch(searchAccountCashBook(data, startDate, endDate)),
      setHeading:(data)=>dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  level5LedgerData: state.AccountLegderReducer.level5LedgerData,
  searchAccountLedgerList: state.AccountLegderReducer.searchAccountLedgerList,
  searchAccountCashBookList:
    state.AccountLegderReducer.searchAccountCashBookList,
  isFetchingSearchAccountCashBook:
    state.AccountLegderReducer.isFetchingSearchAccountCashBook,
  isFetchingLevel5LedgerData:
    state.AccountLegderReducer.isFetchingLevel5LedgerData,
  isFetchingSearchAccountLedger:
    state.AccountLegderReducer.isFetchingSearchAccountLedger,
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountCashBook);
